import React from 'react';
import GoogleIcon from '@/pages/opinion/assets/svg/channel/google.svg';
import TwitterIcon from '@/pages/opinion/assets/svg/channel/twitter.svg';
import { arrayToSimpleObj } from '@/pages/opinion/utils';
import RegionCountryItem from '@/pages/opinion/components/Snippets/RegionCountryItem';

import RankIcon1 from '@/pages/opinion/assets/svg/trends-rank-1.svg';
import RankIcon2 from '@/pages/opinion/assets/svg/trends-rank-2.svg';
import RankIcon3 from '@/pages/opinion/assets/svg/trends-rank-3.svg';

export const dayToDaily = {
  Day: 'daily',
  Hour: 'hourly',
  Week: 'weekly',
  Month: 'monthly',
};
export const dailyToDay = {
  daily: 'Day',
  hourly: 'Hour',
  weekly: 'Week',
  monthly: 'Month',
};

export function getOptionItem(text: string, icon: string) {
  return (
    <div className="dbo-select-flex">
      <RegionCountryItem
        showText={false}
        className="dbo-select-countryicon"
        market={icon}
      ></RegionCountryItem>
    </div>
  );
}

export const platformOptions = (formatMessage: any) => [
  {
    value: 'google',
    text: (
      <div className="dbo-trends-segment-item">
        <span className="dbo-trends-segment-icon">
          <img src={GoogleIcon} />
        </span>
        <span>{formatMessage({ id: 'Google Trends' })}</span>
      </div>
    ),
  },
  {
    value: 'twitter',
    text: (
      <div className="dbo-trends-segment-item">
        <span className="dbo-trends-segment-icon">
          <img src={TwitterIcon} style={{ width: '16px', height: '16px' }} />
        </span>
        <span>{formatMessage({ id: 'X Trends' })}</span>
      </div>
    ),
  },
];

export const languageSelectOptions = [
  { value: 'origin', text: 'Original Language' },
  { value: 'en', text: 'English' },
  { value: 'cn', text: 'Chinese' },
];

export const languageSelectMap = arrayToSimpleObj(languageSelectOptions);

export const topImgMap: any = {
  1: RankIcon1,
  2: RankIcon2,
  3: RankIcon3,
};
export const tagMap = {
  zh: 'tag_zh',
  en: 'tag_en',
  origin: 'tag',
};

export const userTagMap = {
  zh: 'tag_user_zh',
  en: 'tag_user_en',
  origin: 'tag_user',
};
export const titleMap = {
  zh: 'title_zh',
  en: 'title_en',
  origin: 'title',
};

export const commentMap = {
  zh: 'comment_user_zh',
  en: 'comment_user_en',
  origin: 'comment_user',
};

export const newsTitleMap = {
  zh: 'news_title_zh',
  en: 'news_title_en',
  origin: 'news_title',
};

export const relatedNewsTitle = {
  zh: 'title_zh',
  en: 'title_en',
  origin: 'news_title',
};

export const relatedTwitterTitle = {
  zh: 'tweets_content_zh',
  en: 'tweets_content_en',
  origin: 'tweets_content',
};
